import React, { useEffect } from "react";
import { Helmet } from "react-helmet-async";
import { useFeatureFlagVariantKey } from "posthog-js/react";

import Box from "@mui/material/Box";

import WebsiteFooter from "components/Footer/WebsiteFooter";
import IbanHeader from "components/Header/IbanHeader";

import VideoSection from "./VideoSection";
import Statistics from "./Statistics";
import Businesses from "./Businesses";
import MediaPublications from "./MediaPublications";
import BlogArticles from "./BlogArticles";
import Solution from "./Solution";
import HowItWorks from "./HowItWorks";
import SocialProof from "./SocialProof";
import APIIntegration from "./APIIntegration";
import FAQ from "./FAQ";
import ContactUs from "./ContactUs";

import { useAppDispatch } from "store/hooks";
import {
  getLandingStats,
  getLatestBlogArticles,
} from "store/features/homeSlice";

import { featureFlag, testingVariants } from "shared/constants/posthog";
import { defaultContent, abTestContent } from "../SipIbanOplata/variables";

const IbanOplata: React.FC = () => {
  const dispatch = useAppDispatch();

  const homepageTestVariant = useFeatureFlagVariantKey(
    featureFlag.homepage_headlines,
  );

  const isTest = homepageTestVariant === testingVariants.TEST;

  const content = isTest ? abTestContent : defaultContent;

  useEffect(() => {
    dispatch(getLatestBlogArticles());
    dispatch(getLandingStats());
  }, [dispatch]);

  return (
    <>
      <Helmet>
        <link rel="canonical" href={window.location.origin} />
      </Helmet>

      <IbanHeader />

      <Box sx={{ backgroundColor: "#fff" }}>
        <VideoSection
          section={content}
          titleSx={isTest ? { width: { xs: "100%", lg: "90%" } } : {}}
        />
        <Businesses />
        <Statistics />
        <MediaPublications />
        <Solution />
        <APIIntegration />
        <HowItWorks />
        <BlogArticles />
        <SocialProof />
        <FAQ />
        <ContactUs />
      </Box>

      <WebsiteFooter />
    </>
  );
};

export default IbanOplata;
